import { Component, EventEmitter, OnInit, Output } from "@angular/core";

import { fadeInOut } from "src/app/common/animations/animations";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-game-page",
  templateUrl: "./game-page.component.html",
  styleUrls: ["./game-page.component.scss"],
  animations: [fadeInOut],
})
export class GamePageComponent implements OnInit {
  @Output() onRoute = new EventEmitter<void>();

  timeLimit: number = 60;
  timer: any = { minutes: "01", seconds: "00" };
  currentScore: number = 0;
  gameLoaded: boolean = false;
  loading: boolean = false;
  startGame: boolean = false;
  help: boolean = false;

  // ! MAX PROGRESS 96%
  progress: number = 0;

  currentMovements: number = 0;
  movements: number = 0;
  maxMoves: number = 28;
  tiles: string[] = [];

  constructor() {}

  ngOnInit(): void {
    const userPoints = localStorage.getItem(
      "user-points" + environment.storage
    );

    if (userPoints) this.changeRoute();

    this.tiles = ["item_1", "item_2", "item_3", "item_4"];
  }

  changeRoute() {
    this.onRoute.emit();
  }

  generateRandomNumbers(limit: number = 22, size: number = 5): number[] {
    const numbers = new Set<number>();

    while (numbers.size < size) {
      const randomNum = Math.floor(Math.random() * limit) + 1;
      numbers.add(randomNum);
    }

    return Array.from(numbers);
  }

  endGame(_timeOver: any): void {
    localStorage.setItem(
      "user-points" + environment.storage,
      "" + this.currentScore
    );
    localStorage.setItem(
      "user-movements" + environment.storage,
      "" + this.maxMoves
    );

    this.changeRoute();
  }

  timeCounter(time: any) {
    this.timer = time;
  }

  addPoints(point: any) {
    if (typeof point === "number") {
      this.currentScore += point;

      if (this.currentScore > 96) {
        this.progress = 96;
      } else {
        this.progress += point;
      }
    }
  }

  handleMoves(moves: number) {
    this.movements = moves;

    if (this.maxMoves - moves < 0) {
      this.currentMovements = 0;
    } else {
      this.currentMovements = this.maxMoves - moves;
    }
  }
}
